import React, { useRef, useEffect, useState } from 'react'
import * as settings from '../settings.js'

import './styles.scss';

enum Direction {left, right}

const Arrow = ({
  x,
  direction = Direction.right,
  text
}:{
  x: number,
  direction: Direction,
  text: Array<string>
}) => {
  
  const directionValue: number = direction === Direction.left ? 34 : -34;

  return (
    <g className="arrow">
      <path className="arrow"
        transform={`translate(${x + directionValue} 17) scale(2) scale(${1 * direction === Direction.left ? -1 : 1}, 1)`}
        d="M14.28 13.97l1.08-1 .94 1a11.87 11.87 0 00-3.52-8.3C9.31 2.35 4.17 2 2.12 2a9.13 9.13 0 00-.95 0h-.5L.54.58H2.1c2.24 0 7.85.39 11.7 4a13.33 13.33 0 014 9.33l.87-1 1.11 1-2.69 3z"
        fill="#000"
        stroke="white"
      />
      <text
        textAnchor={direction === Direction.right ? "end" : 'begin'}
        y={0}
        fill="grey"
        >
          {text.map((e, i) => <tspan
            key={i}
            dx={0}
            dy={'1em'}
            x={x + 5 * (direction === Direction.left ? 1 : -1) + directionValue}
          >{e}</tspan>)}
      </text>
    </g>
  )
}

const Line = ({
  party,
  board,
  election,
  maxVotes,
  annotation = false
}:{
  party: string,
  board: number,
  election: number,
  maxVotes: number,
  annotation?: boolean
}) => 
{

  const xStart = 0
  const xEnd = 480
  const y = 30
  
  const percentageToPixel = (n: number): number => {
    return ((xEnd - xStart) / maxVotes * n) + xStart
  }

  // Calculate Direction
  let dirElection: Direction = Direction.right
  let dirBoard: Direction = Direction.left

  // Let the textes be as far aways from each other as possible...
  if(election > board)
  {
    dirElection = Direction.left
    dirBoard = Direction.right;
  }

  // ... but if they are near the edge, turn them!
  dirElection = percentageToPixel(election) < 120 ? Direction.left : dirElection
  dirElection = percentageToPixel(election) > percentageToPixel(maxVotes) - 110 ? Direction.right : dirElection
  dirBoard = percentageToPixel(board) < 120 ? Direction.left : dirBoard
  dirBoard = percentageToPixel(board) > percentageToPixel(maxVotes) - 110 ? Direction.right : dirBoard

  const calcTextAnchor = (px, pxNeighbor: number): string => {

    let r: string = "middle";

    // Check Neighbar
    if(Math.abs(px - pxNeighbor) < 40)
    {
      if(px > pxNeighbor) r = "start"
      else r = "end"
    }

    // Override Neighbar if near border
    if(px <= 20) r = "start"
    if(px >= 480) r = "end"
    return r
  }

  return (
    <div className='group'>
    { /* Party Name for mobile */}
    {!annotation &&
      <div className='line hidedesktop'>
        <div className='line'>
          <div className='title'>
            {settings.partyCleaned[party]}
          </div>
        </div>
      </div>
    }

    {/* Title line */}
    {annotation &&
      <div className='line'>
         <div className='title firsttitle hidedesktop'>
            {settings.partyCleaned[party]}
          </div>
        <div className='graph'>

          <svg viewBox="-10 0 503 60">
            <Arrow
              x={percentageToPixel(election)}
              direction={dirElection}
              text={['Ergebnis', 'Kantonsrats-', 'wahlen']}
            />
            <Arrow
              x={percentageToPixel(board)}
              direction={dirBoard}
              text={['Parteistärke in', 'der Exekutiven']}
            />
          </svg>

        </div>
      </div>
    }

    {/* Graph Line */}
    <div className='line'>
      <div className='line'>
        <div className='title hidemobile'>
          {settings.partyCleaned[party]}
        </div>
        <div className='graph'>

          <svg viewBox="-10 0 503 50">
            <line className='dashed' x1={xStart} y1={y} x2={percentageToPixel(election)} y2={y} />
            <line className='filled' x1={xStart} y1={y} x2={percentageToPixel(board)} y2={y} />

            <line className='axis'
              x1={xStart}
              x2={xStart}
              y1={0}
              y2={50}
            />

            <circle className='board'
              cx={percentageToPixel(board)}
              cy={y}
              r={8}
              fill={settings.partyColor[party]}
            />
            <line className='election'
              x1={percentageToPixel(election)}
              x2={percentageToPixel(election)}
              y1={y - 10}
              y2={y + 10}
            />

            <text className='election'
              x={percentageToPixel(election)}
              y={y - 15}
              textAnchor={calcTextAnchor(percentageToPixel(election), percentageToPixel(board))}
            >{election}%</text>

            <text className='board'
              x={percentageToPixel(board)}
              y={y - 15}
              textAnchor={calcTextAnchor(percentageToPixel(board), percentageToPixel(election))}
            >{board}%</text>          

          </svg>

        </div>
      </div>
      </div>
    </div>
  )
}

export const PartyGraph = ({ 
  data,
  userData
}: {
  data: object,
  userData: object,
}) => {

  const percentages = []
  for(let n in data.party)
  {
    if(n != 'verschiedene')
    {
      percentages.push(data.party[n]["2019"])
      percentages.push(data.party[n]["board"])
    }
  }

  return (
    <div className='partygraph'>
      {Object.keys(data.party).filter(p => !["verschiedene", "vacant"].includes(p)).map((p, i) => <Line
        key = {p}
        annotation = {i === 0}
        party = {p}
        board = {data.party[p].board}
        election = {data.party[p]['2019']}
        maxVotes = {Math.max(...percentages)}
      />)}
    </div>
  )
}
